import React, { Component } from "react";
import Grid from '@material-ui/core/Grid';
import ReactPaginate from 'react-paginate';
import { Router } from "routes";

class Pagination extends Component {
    constructor(props){
        super(props);
        this.handlePageClick = this.handlePageClick.bind(this);
    }
    handlePageClick = (data) => {
        const { query } = this.props;
        let selected = data.selected;
        let page = selected + 1;
            this.setState({page: page},window.scrollTo(0, 0));
            let q = query.q
            let sort = query.sort
            let sc = query.sc
            Router.pushRoute(`/search-results?q=${q}&sc=${sc}&page=${page}&sort=${sort}`)
        };
  render() {
    const { lastPage, page, query } = this.props;
    return (
        <Grid container direction="row"
            justify="center"
            alignItems="center">
            <Grid item xs={12} md={8} style={{ marginBottom: 10 }}>
                <ReactPaginate previousLabel={'prev'}
                nextLabel={'next'}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={lastPage}
                marginPagesDisplayed={2}
                pageRangeDisplayed={2}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
                forcePage={page ? page-1: 0}
                /> 
            </Grid>
        </Grid>
    );
  }
}

export default Pagination;
